import React from 'react';
import { AlertCircle } from 'react-feather';

const ErrorState = ({ message, onRetry, onLibrary }) => (
	<div className="image-upload-control__error" role="alert">
		<div className="image-upload-control__error-tile" aria-hidden="true">
			<AlertCircle size={20} />
		</div>
		<div style={{ flex: 1 }}>
			<div className="image-upload-control__error-title">Upload failed</div>
			<div className="image-upload-control__error-message">{message}</div>
			<div className="image-upload-control__error-actions">
				<button type="button" className="image-upload-control__btn-primary" onClick={onRetry}>
					Try again
				</button>
				<button type="button" className="image-upload-control__btn-secondary" onClick={onLibrary}>
					Choose from library
				</button>
			</div>
		</div>
	</div>
);

export default ErrorState;
